import React from 'react';
import FWorkbookImport from '../core/FWorkbookImport';
import { fileToPayload } from './filePayload';
import {
  downloadHistoricalTemplate,
  importHistoricalWorkbook,
  validateHistoricalWorkbook,
} from './bieHistorical.apis';

type Props = {
  metricCode?: string;
  fiscalYear?: string;
  onCompleted?: (result:any) => void;
};

class HistoricalWorkbookPanel extends React.PureComponent<Props> {
  private downloadTemplate = async () => {
    const result = await downloadHistoricalTemplate({
      metricCode: this.props.metricCode,
      fiscalYear: this.props.fiscalYear,
    });

    const href = result?.url || result?.displayurl || result?.downloadurl;
    if (href) window.open(href, '_blank', 'noopener,noreferrer');
  };

  private validate = async (file:File) =>
    validateHistoricalWorkbook({
      ...(await fileToPayload(file)),
      mtc: this.props.metricCode || null,
      fyr: this.props.fiscalYear || null,
    });

  private upload = async (file:File) =>
    importHistoricalWorkbook({
      ...(await fileToPayload(file)),
      mtc: this.props.metricCode || null,
      fyr: this.props.fiscalYear || null,
    });

  render() {
    return (
      <FWorkbookImport
        title="Historical Data Workbook"
        description="Use the controlled template to import product and period facts without entering JSON."
        onDownloadTemplate={this.downloadTemplate}
        onValidate={this.validate}
        onUpload={this.upload}
        onCompleted={this.props.onCompleted}
      />
    );
  }
}

export default HistoricalWorkbookPanel;
